import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import useForkRef from '../../../hooks/use-fork-ref.esm.js';
import useIsomorphicEffect from '../../../hooks/use-isomorphic-effect.esm.js';
import ThemeUIProvider from '../../../theme-provider/theme-ui-provider.esm.js';
import { useSafeThemeUI } from '../../../theme-provider/use-theme-ui.esm.js';
import setRef from '../../../utils/set-ref.esm.js';

function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  // #StrictMode ready
  // eslint-disable-next-line react/no-find-dom-node
  return ReactDOM.findDOMNode(container);
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */
var Portal = /*#__PURE__*/React.forwardRef(function Portal(props, ref) {
  var children = props.children,
    container = props.container,
    _props$disablePortal = props.disablePortal,
    disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
    shouldHoistTheme = props.shouldHoistTheme;
  var theme = useSafeThemeUI(props);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mountNode = _useState2[0],
    setMountNode = _useState2[1];
  var handleRef = useForkRef(
  // @ts-ignore
  /*#__PURE__*/React.isValidElement(children) ? children.ref : null, ref);
  useIsomorphicEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useIsomorphicEffect(function () {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return function () {
        setRef(ref, null);
      };
    }
    return undefined;
  }, [ref, mountNode, disablePortal]);
  if (disablePortal) {
    if (/*#__PURE__*/React.isValidElement(children)) {
      return /*#__PURE__*/React.cloneElement(children, {
        ref: handleRef
      });
    }
    return /*#__PURE__*/React.isValidElement(children) ? children : null;
  }
  function wrapThemeUIProvide() {
    return shouldHoistTheme ? /*#__PURE__*/React.createElement(ThemeUIProvider, {
      theme: theme,
      hoistContext: true
    }, children) : children;
  }
  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(wrapThemeUIProvide(), mountNode) : mountNode;
});

// @ts-ignore
Portal.__className = '__csg-tui-portal';
// @ts-ignore
Portal.__selector = ".".concat(Portal.__className);

export default Portal;
//# sourceMappingURL=portal.esm.js.map
